import React from 'react';
import { ReactComponent as LoaderSVG } from '../../assets/icons/loader.svg';
import { Container } from './Loader.style';

const Loader = (props) => (
  <Container {...props}>
    <LoaderSVG />
  </Container>
);

export default Loader;
